// extracted by mini-css-extract-plugin
module.exports = {"metadataPackageTitle":"styles-module_metadataPackageTitle__MTgvsDfbTHP3tg6o8nm3"};